/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PackageSubscription from './package-subscription';
import PackageSubscriptionDetail from './package-subscription-detail';
import PackageSubscriptionUpdate from './package-subscription-update';
import PackageSubscriptionDeleteDialog from './package-subscription-delete-dialog';

const PackageSubscriptionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PackageSubscription />} />
    <Route path="new" element={<PackageSubscriptionUpdate />} />
    <Route path=":id">
      <Route index element={<PackageSubscriptionDetail />} />
      <Route path="edit" element={<PackageSubscriptionUpdate />} />
      <Route path="delete" element={<PackageSubscriptionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PackageSubscriptionRoutes;
